import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../authContext"
import RedirectLoader from "../../components/RedirectLoader"

const NonSellerRoute = ({ children }) => {
  const { currentUser, loading } = useAuth()
  const navigate = useNavigate()
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    if (loading) return // Esperar a que termine de cargar la auth

    if (currentUser && currentUser.photoURL === "vendedor") {
      navigate("/profile", { replace: true })
      return
    } else if (currentUser && currentUser.photoURL === "admin") {
      navigate("/admin", { replace: true })
      return
    }
    
    // Solo renderizar si el usuario puede ver esta ruta
    setShouldRender(true)
  }, [currentUser, navigate, loading])

  // Mostrar loading mientras se está cargando o redirigiendo
  if (loading) {
    return <RedirectLoader />
  }

  // Si es vendedor o admin, mostrar loader mientras redirige
  if (currentUser && (currentUser.photoURL === "vendedor" || currentUser.photoURL === "admin")) {
    return <RedirectLoader />
  }

  return shouldRender ? children : null
}

export default NonSellerRoute
